import React from 'react';

const CareersProcess: React.FC = () => {
  const steps = [
    {
      number: '1',
      title: 'Apply online',
      description: 'Submit your application through our careers portal. We review each application carefully and will reach out if there\'s a potential match for current or future opportunities.'
    },
    {
      number: '2',
      title: 'Technical & practical assessments',
      description: 'Depending on the role, you may complete coding challenges, cloud architecture designs, data analysis tasks, or teaching demonstrations that showcase your skills.'
    },
    {
      number: '3',
      title: 'Conversations & culture fit',
      description: 'Meet with your potential teammates and leadership team. We\'ll discuss your experience, aspirations, and how you can contribute to our mission of transforming technology education.'
    }
  ];

  return (
    <section className="careers-section careers-process">
      <div className="container">
        <h2 className="section-title">Our hiring journey</h2>
        <p className="section-subtitle">
          A transparent and comprehensive process designed to find the right fit for both you and our team.
        </p>
        
        <div className="process-steps">
          {steps.map((step, index) => (
            <div key={index} className="process-step">
              <div className="step-number">{step.number}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CareersProcess;